import React from 'react';
import classNames from 'classnames';
import css from './styles.module.scss';
import { ReactComponent as LogoWithTextSVG } from '~/img/logo-with-text.svg';
import { Box, BoxProps } from '@material-ui/core';

type LoaderProps = BoxProps & {};

export const Loader: React.FC<LoaderProps> = ({ className, ...props }) => {
    return (
        <Box className={classNames('loader', css.module, className)} {...props}>
            <LogoWithTextSVG />
        </Box>
    );
};
